import { object, string, pipe, check, nullable } from 'valibot'

import { ERROR_MESSAGES } from '@/constants/common/message.constants'

/**
 * ファイルアップロードのスキーマ
 */
export const uploadFileSchema = nullable(
  object({
    key: string(),
    name: string()
  })
)

/**
 * 必須項目のファイルアップロードのスキーマ
 */
export const requireUploadFileSchema = pipe(
  uploadFileSchema,
  check(
    (file) => file !== null && file.key.length > 0 && file.name.length > 0,
    ERROR_MESSAGES.SELECT_FILE
  )
)
